import React, { Component } from 'react';
import { translate } from '../Services/translation';
import { connect } from 'react-redux';
import { updateCartDeliveryAddress, createOrder, addAddress, getAllCustomerAddresses, getCartByCartId, updateCartPaymentMode, getProductStockByEan, createAndOrAddToCart, getCurrentCustomer, displayLoader } from '../actions/Bahag.action';

class BahagCustomerInfoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: {
                email: "",
                phone: "",
                firstName: "",
                lastName: "",
                address: "",
                zipCode: "",
                city: "",
                houseNumber: ""
            },
            errorMessage: "",
            isShowValidationErrorMessage: false,
        };
        this.handleCustomerFormSubmit = this.handleCustomerFormSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.createNewOrder = this.createNewOrder.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.isActiveCustomerAddress && !prevProps.isActiveCustomerAddress) {
            const { currentCustomer } = this.props;

            const defaultShippingAddress = currentCustomer.default_shipping_address;
            this.setState({
                formData: {
                    email: defaultShippingAddress.email,
                    phone: defaultShippingAddress.phone,
                    firstName: defaultShippingAddress.first_name,
                    lastName: defaultShippingAddress.last_name,
                    address: defaultShippingAddress.street_name,
                    zipCode: defaultShippingAddress.postal_code,
                    city: defaultShippingAddress.town,
                    houseNumber: defaultShippingAddress.street_number
                },
                isShowValidationErrorMessage: false,
                errorMessage: ""
            });
        }

        if (prevProps.isActiveCustomerAddress && !this.props.isActiveCustomerAddress) {
            this.setState({
                formData: {
                    email: "",
                    phone: "",
                    firstName: "",
                    lastName: "",
                    address: "",
                    zipCode: "",
                    city: "",
                    houseNumber: ""
                },
                isShowValidationErrorMessage: false,
                errorMessage: ""
            });
        }
    }

    renderCustomerPersonalForm() {
        const { firstName, lastName, address, zipCode, city, email, phone, houseNumber } = this.state.formData;

        return (
            <form onSubmit={(event) => this.handleCustomerFormSubmit(event)}>
                <div className='germany-section__container' id="bahag-customer-address">
                    <h3 className="checkout__section-title">{translate('checkout.customer.address.form.header')}</h3>

                    {this.state.isShowValidationErrorMessage && 
                        <div className="checkout__section-error-message">
                            <p>{this.state.errorMessage}</p>
                        </div>
                    }
                    <div className='customer-Form__inner'>
                        <div className='customer-Form__input-halve'>
                            <input
                                className='customer-Form__inner--input'
                                type='text'
                                name="firstName"
                                placeholder={translate('checkout.customer.address.form.firstName')}
                                required
                                onChange={this.handleChange}
                                value={firstName}
                            />
                            <input
                                className='customer-Form__inner--input'
                                type='text'
                                name="lastName"
                                placeholder={translate('checkout.customer.address.form.lastName')}
                                required
                                onChange={this.handleChange}
                                value={lastName}
                            />
                        </div>
                        <div className='customer-Form__input-full'>
                            <input
                                className='customer-Form__inner--input customer-Form__input-full--address'
                                type='text'
                                name="address"
                                placeholder={translate('checkout.customer.address.form.address')}
                                required
                                onChange={this.handleChange}
                                value={address}
                            />
                            <input
                                className='customer-Form__inner--input customer-Form__input-full--number'
                                type='text'
                                name="houseNumber"
                                placeholder={translate('checkout.customer.address.form.house.number')}
                                required
                                onChange={this.handleChange}
                                value={houseNumber}
                                maxLength="5"
                            />
                        </div>
                        <div className='customer-Form__input-one-third'>
                            <input
                                className='customer-Form__inner--input'
                                type='text'
                                name="zipCode"
                                placeholder={translate('checkout.customer.address.form.zip.code')}
                                required
                                onChange={this.handleChange}
                                value={zipCode}
                            />
                            <input
                                className='customer-Form__inner--input'
                                type='text'
                                name="city"
                                placeholder={translate('checkout.customer.address.form.city')}
                                required
                                onChange={this.handleChange}
                                value={city}
                            />
                        </div>
                        <div className='customer-Form__input-halve'>
                            <input
                                className='customer-Form__inner--input'
                                type='email'
                                name="email"
                                placeholder={translate('checkout.customer.address.form.email')}
                                required
                                onChange={this.handleChange}
                                value={email}
                                disabled
                            />
                            <input
                                className='customer-Form__inner--input'
                                type='phone'
                                name="phone"
                                placeholder={translate('checkout.customer.address.form.phone')}
                                required
                                onChange={this.handleChange}
                                value={phone}
                            />
                        </div>
                        <button className="customer-Form__submit-button" type="submit">{translate('checkout.customer.address.form.submit.button')}</button>
                    </div>
                    <div className='germany-checkout-cartArrow'></div>
                </div>
            </form>
        )
    }

    async handleCustomerFormSubmit(event) {
        event.preventDefault();
        this.setState({
            isShowValidationErrorMessage: false,
            errorMessage: "",
        })
        const { firstName, lastName, email, phone, city, zipCode, address, houseNumber } = this.state.formData;
        let authorizationHybris = this.props.authorizationHybris;
        const customerId = this.props.currentCustomer.pk;
        let validationPassed = true;

        //Validation
        if (firstName && (firstName.length < 2 || firstName.length > 34)) {
            this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.firstname.length") });
            validationPassed = false;
        }
        else if (lastName && (lastName.length < 2 || lastName.length > 35)) {
            this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.lastname.length") });
            validationPassed = false;
        }
        else if (address && (address.length < 2 || address.length > 2147483647)) {
            this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.address.length") });
            validationPassed = false;
        }
        else if (city && (city.length < 2 || city.length > 35)) {
            this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.city.length") });
            validationPassed = false;
        }
        else if (phone && !/( )*(0|\+)([0-9]| |[\+\-()/])*/.test(phone)) {
            this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.phone.form") });
            validationPassed = false;
        }

        if (authorizationHybris !== null && validationPassed === true) {
            this.props.displayLoader(true);
            const currentUser = await this.props.currentCustomer;
            const defaultShippingAddress = currentUser.default_shipping_address;
            const defaultBillingAddress = currentUser.default_billing_address;
            let allAddresses = [];
            await allAddresses.push(defaultShippingAddress, defaultBillingAddress);
            if (currentUser.addresses && currentUser.addresses.length > 0) {
                const otherAddresses = currentUser.addresses;
                otherAddresses.forEach(address => {
                    allAddresses.push(address);
                });
            }
            if (allAddresses !== null) {
                const addressToAdd = {
                    address_type: "SHIPPING",
                    street_name: address,
                    first_name: firstName,
                    last_name: lastName,
                    postal_code: zipCode,
                    town: city,
                    phone: phone,
                    house_number: houseNumber,
                    is_default_address: false
                };

                const addressToCompare = {
                    address_type: "SHIPPING",
                    street_name: address,
                    first_name: firstName,
                    last_name: lastName,
                    postal_code: zipCode,
                    town: city,
                    phone: phone,
                    street_number: houseNumber
                };

                let foundMatchingAddress = false;
                let addressId = null;

                for (const parsedAddress of allAddresses) {
                    if (
                        parsedAddress.street_name === addressToCompare.street_name &&
                        parsedAddress.first_name === addressToCompare.first_name &&
                        parsedAddress.last_name === addressToCompare.last_name &&
                        parsedAddress.postal_code === addressToCompare.postal_code &&
                        parsedAddress.town === addressToCompare.town &&
                        parsedAddress.phone === addressToCompare.phone &&
                        parsedAddress.house_number === addressToCompare.house_number
                    ) {
                        foundMatchingAddress = true;
                        addressId = parsedAddress.id;
                        break;
                    }
                }

                if (!foundMatchingAddress || addressId === null) {
                    const addAddressToCustomer = await this.props.addAddress(addressToAdd, authorizationHybris);
                    if (addAddressToCustomer.Data) {
                        const addAddressRes = await JSON.parse(addAddressToCustomer.Data);
                        if (addAddressRes && addAddressRes.title === "Validation failure") {
                            this.setState({ isShowValidationErrorMessage: true, errorMessage: translate("checkout.customer.address.form.error.message.postalcode.form") });
                        }
                        else {
                            addressId = addAddressRes.id;
                        }
                    }
                }

                if (customerId && addressId) {
                    await this.createAndAddProductCart();
                    const cartId = this.props.cartInfo.code;
                    const updateCartDeliveryAddress = await this.props.updateCartDeliveryAddress(cartId, customerId, addressId, authorizationHybris);
                    const updateCartPaymentMode = await this.props.updateCartPaymentMode(cartId, authorizationHybris, "PayPalPayment");
                    await this.createNewOrder(cartId, customerId, authorizationHybris);
                }

                this.props.displayLoader(false);
            }
            
        }
    }

    async getProductsToAddToCart() {
        const orderRows = this.props.cartOrderRows;
        let products = [];

        if (orderRows) {
            for (let i = 0; i < orderRows.length; i++) {
                let orderRowQuantity = orderRows[i].quantity;
                let productStock = await this.props.getProductStockByEan(orderRows[i].itemEAN);
                if (productStock && productStock.amount >= orderRowQuantity) {
                    let product = {
                        quantity: orderRowQuantity,
                        ean: orderRows[i].itemEAN,
                    };
                    products.push(product);
                }
            }
        }
        return products
    }

    async getCustomerId() {
        const currentCustomer = await this.props.currentCustomer;
        let customerId = "";
        if (currentCustomer) {
            customerId = currentCustomer.pk;
        }
        return customerId;
    }

    async createAndAddProductCart() {
        const authorizationHybris = await this.props.authorizationHybris;
        const customerId = await this.getCustomerId();
        let products = await this.getProductsToAddToCart();

        //Cart Id null here it will replace on BE with newcart
        if (products && products.length > 0 && customerId && (authorizationHybris !== "" || authorizationHybris !== null || authorizationHybris !== undefined)) {
            const createAndAddToCartResult = await this.props.createAndOrAddToCart(customerId, null, products, authorizationHybris);
        }
    }

    getTotalPrice() {
        const totalPriceElement = document.getElementById('checkout-total-price');
        if (totalPriceElement) {
            const textContent = totalPriceElement.textContent;
            const numericValue = parseFloat(textContent.replace(/[^\d.,]+/g, ''))
            return numericValue;
        }
        return null;
    }

    async createNewOrder(cartId, customerId, authorizationHybris) {
        const totalPrice = this.getTotalPrice();
        const createOrderResponse = await this.props.createOrder(cartId, customerId, authorizationHybris);
        let orderResParsed = null;
        let cancelUrl = "";
        let redirectUrl = "";
        let successUrl = "";
        let code = ""
        let paymentMethod = "Paypal payment";
        let formData = this.state.formData;

        if (createOrderResponse.Data) {
            orderResParsed = JSON.parse(createOrderResponse.Data);
        }

        if (orderResParsed) {
            const currentDate = new Date().toISOString().slice(0, 16).replace('T', ' ');
            cancelUrl = orderResParsed.payment_info.cancel_url;
            redirectUrl = orderResParsed.payment_info.redirect_url;
            successUrl = orderResParsed.payment_info.success_url;
            code = orderResParsed.code;
            const orderData = {
                orderRows: this.props.cartOrderRows,
                orderNumber: code,
                paymentMethod: paymentMethod,
                customerInfo: formData,
                totalPrice: totalPrice,
                orderDate: currentDate
            };
            // delivery cost and time is hard coded, so not stored in here
            sessionStorage.setItem('orderData', JSON.stringify(orderData));
            window.location.href = redirectUrl;
        }
    }

    handleChange(event) {
        const fieldName = event.target.name;
        const newValue = event.target.value;

        this.setState(prevState => ({
            formData: {
                ...prevState.formData,
                [fieldName]: newValue
            },
        }));
    }

    render() {
        return (
            <div>
                {this.renderCustomerPersonalForm()}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        isActiveCustomerAddress: state.bahag.isActiveCustomerAddress,
        cartInfo: state.bahag.cartInfo,
        orderInfo: state.bahag.orderInfo,
        authorizationHybris: state.bahag.authorizationHybris,
        cartOrderRows: state.cart.orderRows,
        currentCustomer: state.bahag.currentCustomer,
        orderRowsWithStock: state.bahag.orderRowsWithStock
    };
};

const mapDispatchToProps = (dispatch) => ({
    updateCartDeliveryAddress: (cartId, customerId, addressId, authorizationHybris) => dispatch(updateCartDeliveryAddress(cartId, customerId, addressId, authorizationHybris)),
    addAddress: (deviceId, authorizationHybris) => dispatch(addAddress(deviceId, authorizationHybris)),
    createOrder: (cartId, customerId, authorizationHybris) => dispatch(createOrder(cartId, customerId, authorizationHybris)),
    getAllCustomerAddresses: (authorizationHybris) => dispatch(getAllCustomerAddresses(authorizationHybris)),
    getCartByCartId: (cartId, authorizationHybris) => dispatch(getCartByCartId(cartId, authorizationHybris)),
    updateCartPaymentMode: (cartId, authorizationHybris, paymentMode) => dispatch(updateCartPaymentMode(cartId, authorizationHybris, paymentMode)),
    getProductStockByEan: (ean) => dispatch(getProductStockByEan(ean)),
    createAndOrAddToCart: (customerId, cartId, products, authorizationHybris) => dispatch(createAndOrAddToCart(customerId, cartId, products, authorizationHybris)),
    displayLoader: (isLoaderActive) => dispatch(displayLoader(isLoaderActive)),
});

export default connect(mapStateToProps, mapDispatchToProps)(BahagCustomerInfoForm);